﻿export default class AccessibleToolTip {

    tooltipSelector = '[data-js-tooltip]'
    toggleSelector = '[data-js-tooltip-toggle]'
    tooltipContent = '[data-js-tooltip-content]'
    hiddenClass = 'js-hidden'

    constructor() {
        this.tooltips = document.querySelectorAll(this.tooltipSelector);
        this.toggles = document.querySelectorAll(this.toggleSelector);
        this.init();
    }

    // set tooltips to be visible by default, in case js is not on
    init = () => {
        if (this.tooltips) {
            this.tooltips.forEach((tooltip) => {
                tooltip.setAttribute('aria-hidden', 'true');
                tooltip.classList.add(this.hiddenClass);
            })

            this.eventListeners();
        }
    }

    eventListeners = () => {

        // listen to tab, escape and click
        if (this.toggles) {

            ['click', 'keyup', 'focus', 'blur'].forEach((event) => {

                this.toggles.forEach((toggle) => {
                    toggle.addEventListener(event, (e) => {

                        if (event === 'click') {
                            e.preventDefault();
                            toggle.focus();
                            this.collectMessages(e)
                        }

                        if (event === 'focus') {
                            e.preventDefault();
                            this.collectMessages(e)
                        }

                        if (event === 'blur') {
                            e.preventDefault();
                            this.closeToolTip(e);
                        }

                        if (event === 'keyup' && e.key === 'Escape') {
                            e.preventDefault();
                            this.closeToolTip(e)
                        }
                    })
                })
            })
        }
    }

    // get message to add to the tooltip
    collectMessages = (e) => {
        let message;

        if (this.toggles) {
            this.toggles.forEach((toggle) => {
                message = toggle.dataset.jsTooltipContent;
            })
            this.openToolTip(e, message);
        }
     }


    openToolTip = (event, message) => {
        const target = event.target;
        let tooltip;
        tooltip = target.nextElementSibling;

        if (tooltip) {
            tooltip.removeAttribute('aria-hidden', 'true');
            tooltip.setAttribute('aria-hidden', 'false');
            tooltip.classList.remove(this.hiddenClass);

            tooltip.previousElementSibling.setAttribute('aria-expanded', 'true')

            tooltip.innerHTML = ` <span class="accordion-tooltip__arrow"></span><span class="accordion-tooltip__content__text">${message}</span>`
        }
    }

    closeToolTip = (event) => {
        const target = event.target;
        let tooltip;
        tooltip = target.nextElementSibling;

        if (tooltip) {
            tooltip.removeAttribute('aria-hidden', 'false');
            tooltip.setAttribute('aria-hidden', 'true');
            tooltip.classList.add(this.hiddenClass);

            tooltip.previousElementSibling.setAttribute('aria-expanded', 'false')

            tooltip.innerHTML = '';
        }
    }
}